import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Section from '../../components/layout/Section';
import ContentPlain from '../../components/layout/ContentPlain';
import PresaleBasicInformation from './components/PresaleBasicInformation'
import ProductActions from '../../store/productRedux';
import PaymentInfo from '../../components/paymentInformation/PaymentInfo'

const DIYPresalePage = () => {
    const { id, taxYear } = useParams();

    const dispatch = useDispatch();
    const presale = useSelector(state => state.product.selectedPresale);

    useEffect(() => {
        document.getElementById('overflow-container').scrollTo({ top: 0, behavior: 'smooth' });
        if (id) {            
            // request data for newly selected id
            dispatch(ProductActions.getSelectedPresale({ id: id, taxYear: taxYear }))
        }
    }, [id]);

    return (
        <div className="content-grid tickets">
            <Section sectionId='section-presale' className='white'>
                <ContentPlain elementId='content-greeting'>
                    <PresaleBasicInformation presale={presale} />
                </ContentPlain>
            </Section> 
            <Section sectionId='section-payments' className='light-functional-grey'>
                <ContentPlain elementId='content-presale-payments'>
                    <div className='columns'>
                        <div className='column is-12'>
                            <PaymentInfo payments={presale ? presale.paymentInformation : null} />
                        </div>
                    </div>
                </ContentPlain>
            </Section>            
        </div>
    );
}

export default DIYPresalePage